import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import NotFound from '../../Common/NotFound/NotFound';
import Administrators from '../Users/Administrators/Administrators';
import OrganisationNonContributors from '../Users/OrganisationNonContributors/OrganisationNonContributors';
import AllUsers from '../Users/AllUsers/AllUsers';
import Users from '../Users/Users/Users';
import User from '../Users/User/User';
import InviteUser from '../Users/InviteUser/InviteUser';
import Teams from '../Teams/Teams/Teams';
import CreateTeam from '../Teams/CreateTeam/CreateTeam';
import EditTeam from '../Teams/Teams/Team/EditTeam/EditTeam';
import GoalHierarchy from '../Goals/GoalHierarchy/GoalHierarchy';
import EditGoalHierarchy from '../Goals/GoalHierarchy/EditGoalHierarchy/EditGoalHierarchy';
import Goals from '../Goals/Goals/Goals';
import Goal from '../Goals/Goal/Goal';
import Team from '../Teams/Teams/Team/Team';
import Dashboard from '../Organisation/Dashboard/Dashboard';
import Cycles from '../Organisation/Cycles/Cycles';
import CreateCycle from '../Organisation/Cycles/CreateCycle/CreateCycle';
import Cycle from '../Organisation/Cycles/Cycle/Cycle';
import EditCycle from '../Organisation/Cycles/EditCycle/EditCycle';
import Meetings from '../Organisation/Meetings/Meetings';
import Commitments from '../Organisation/Commitments/Commitments';
import MeetingDetailsViewPathWrapper from '../../Common/MeetingDetailsView/MeetingDetailsViewPathWrapper';
import GroupBasedAuthenticator from '../../../_functional/GroupBasedAuthenticator';

function AdministratorLayout() {
  return (
    <Routes>
      <Route index element={<Navigate to="organisation" />} />
      <Route path="organisation/*">
        <Route index element={<Dashboard />} />
        <Route path="cycles/*">
          <Route index element={<Cycles />} />
          <Route path="create" element={GroupBasedAuthenticator(CreateCycle, ['administrators'])()} />
          <Route path=":cycleId">
            <Route index element={<Cycle />} />
            <Route path="edit" element={GroupBasedAuthenticator(EditCycle, ['administrators'])()} />
          </Route>
        </Route>
        <Route path="meetings/*">
          <Route index element={<Meetings />} />
        </Route>
        <Route path="commitments/*">
          <Route index element={<Commitments />} />
        </Route>
      </Route>
      <Route path="goals/*">
        <Route index element={<Goals />} />
        <Route path="hierarchy">
          <Route index element={<GoalHierarchy />} />
          <Route path="edit" element={GroupBasedAuthenticator(EditGoalHierarchy, ['administrators'])()} />
        </Route>
        <Route path=":goalId">
          <Route index element={<Goal />} />
        </Route>
      </Route>
      <Route path="teams/*">
        <Route index element={<Teams />} />
        <Route path="create" element={GroupBasedAuthenticator(CreateTeam, ['administrators'])()} />
        <Route path=":teamId">
          <Route index element={<Team />} />
          <Route path="edit" element={GroupBasedAuthenticator(EditTeam, ['administrators'])()} />
          <Route path="meetings/*">
            <Route index element={<Navigate to=".." />} />
            <Route path=":meetingId">
              <Route index element={<Navigate to="details" />} />
              <Route path="details" element={<MeetingDetailsViewPathWrapper isAdministratorView />} />
            </Route>
          </Route>
        </Route>
      </Route>
      <Route path="users/*">
        <Route index element={<AllUsers />} />
        <Route path="invite" element={GroupBasedAuthenticator(InviteUser, ['administrators'])()} />
        <Route path="administrators" element={<Administrators />} />
        <Route path="organisationNonContributors" element={<OrganisationNonContributors />} />
        <Route path="users" element={<Users />} />
        <Route path=":userId" element={<User />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default GroupBasedAuthenticator(AdministratorLayout, ['administrators', 'organisationNonContributors']);
